import client from "../client/client";

class AiCompanyTokenQuotaService {
	getAllQuotas(cancelToken) {
		return client.get("/ai-token-quotas", {
			config: { cancelToken },
		});
	}

	getAllQuotasConsumptions(cancelToken) {
		return client.get("/ai-token-quotas/consumptions", {
			config: { cancelToken },
		});
	}

	getHasAvailableAIQuota(cancelToken) {
		return client.get("/ai-token-quotas/has-quota", {
			config: { cancelToken },
		});
	}
}
export default new AiCompanyTokenQuotaService();
